import { heldState } from '../activationStateCache';
import { AvailabilitySource, webAvailability } from './availability';

export const DEFAULT_RETURN_NOTICE_WINDOW_MS = 3_600_000;
export const DEFAULT_C5_THRESHOLD_MS = 300_000;

export type BannerSlot = 'cloud' | 'offline';

export type HeldActivation = {
  isActive: boolean;
  updatedAt: number;
};

export type CloudReplica = {
  isActive: boolean;
};

export type Connectivity = {
  degraded: boolean;
};

export type BannerInputs = {
  viewing: BannerSlot;
  nowMs: number;
  held: HeldActivation | null;
  replica: CloudReplica | null;
  probedThisLaunch: boolean;
  onLocalNetwork: boolean | null;
  registered: boolean | null;
  heartbeatStale: boolean | null;
  connectivity: Connectivity;
  degradedSinceMs: number | null;
  testOverrideActive: boolean;
  orgProvisionedForOfflineMode: boolean;
  returnNoticeWindowMs: number;
  c5ThresholdMs: number;
};

export type BannerInputsSource = AvailabilitySource & {
  statesByOrg: Record<string, HeldActivation>;
};

export type BuildBannerInputsOptions = {
  orgToken: string;
  store: BannerInputsSource;
  nowMs: number;
  viewing: BannerSlot;
  connectivity: Connectivity;
  replica?: CloudReplica | null;
  heartbeatStale?: boolean | null;
  degradedSinceMs?: number | null;
  testOverrideActive?: boolean;
  orgProvisionedForOfflineMode?: boolean;
  returnNoticeWindowMs?: number;
  c5ThresholdMs?: number;
};

export function buildBannerInputs({
  orgToken,
  store,
  nowMs,
  viewing,
  connectivity,
  replica = null,
  heartbeatStale = null,
  degradedSinceMs = null,
  testOverrideActive = false,
  orgProvisionedForOfflineMode = false,
  returnNoticeWindowMs = DEFAULT_RETURN_NOTICE_WINDOW_MS,
  c5ThresholdMs = DEFAULT_C5_THRESHOLD_MS,
}: BuildBannerInputsOptions): BannerInputs {
  const { probedThisLaunch, onLocalNetwork, registered } = webAvailability(orgToken, store, nowMs);
  const held = store.statesByOrg[orgToken] ?? heldState(orgToken);

  return {
    viewing,
    nowMs,
    held: held ? { isActive: held.isActive, updatedAt: held.updatedAt } : null,
    replica,
    probedThisLaunch,
    onLocalNetwork,
    registered,
    heartbeatStale,
    connectivity,
    degradedSinceMs,
    testOverrideActive,
    orgProvisionedForOfflineMode,
    returnNoticeWindowMs,
    c5ThresholdMs,
  };
}
